export default {
  data: () => {
    return {
      nowSort: "",
      nowName: "",
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add",
          disabled: false
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit",
          disabled: false
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete",
          disabled: false,
          class: "invalid"
        }
      ],
      tableColumns: [
        {
          label: "功能名称",
          prop: "functionName"
        },
        {
          label: "响应路径",
          prop: "action"
        },
        {
          label: "路由路径",
          prop: "path"
        },
        {
          label: "路由名称",
          prop: "name"
        },
        {
          label: "序号",
          prop: "order"
        },
      ],
      tableData: [],
      // 勾选的数据
      multipleSelection: [],
      // 添加包内容弹窗状态
      dialogVisible: false,
      controllerFlg: null,// 操作标志
      // 表单字段
      form: {
        id: null,
        processSetId: null,  // 流程设定编号
        processSetName: null, // 流程设定名称
        functionName: null, // 功能名称
        order: null, // 序号
        action: null, // 访问方法
        pid: null, // 父ID
        operationId: null, // 操作编号
        path: null, // 路由路径
        name: null, // 路由名称
      },
      // 后台校验规则
      errRules: {
        id: null,
        processSetId: null,  // 流程设定编号
        processSetName: null, // 流程设定名称
        functionName: null, // 功能名称
        order: null, // 序号
        action: null, // 访问方法
        pid: null, // 父ID
        operationId: null, // 操作编号
        path: null, // 路由路径
        name: null, // 路由名称
      },
      // 修改状态
      editFlag: false,
      // 表单配置
      formConfigList: [
        {
          type: "input",
          label: "功能名称：",
          value: "functionName",
          disabled: false,
          rule: {
            required: true,
            message: "请选择功能名称",
            trigger: "change"
          }
        },
        {
          type: "select",
          label: "操作流程：",
          value: "processSetName",
          placeholder: "请选择",
          disabled: false,
          filterable: true,
          clearable: true,
          queryParams: {
            url: "/supervisorPower/getAllMenu",
          },
          rule: {
            required: true,
            message: "请选择操作流程",
            trigger: "change"
          }
        },
        {
          label: "响应路径：",
          value: "action",
          type: "input",
          disabled: true
        },
        {
          label: "路由路径：",
          value: "path",
          type: "input",
          disabled: true
        },
        {
          label: "路由名称：",
          value: "name",
          type: "input",
          disabled: true
        },
        {
          label: "序号：",
          value: "order",
          type: "input",
          disabled: true
        },
      ],
    };
  },
  // 接收来自父组件的数据
  props: {
    controllerFlg: {
      type: String,
      default: "",
    }
  },
  watch: {
    type(a) {
      if (a && a === "details") {
        this.btnList.map(e => {
          e.disabled = true;
        });
      }
    }
  },
  methods: {
    /**
     * 弹窗提交
     * @author 滕威
     */
    fun_GetInfoTable() {
      // 去掉首尾空格
      for (const key in this.form) {
        if (this.form[key] && typeof this.form[key] === "string") this.form[key] = this.form[key].trim();
      }
      // 表单验证
      this.$refs.form.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 重新定义表单对象
          let obj = {
            id: null,
            processSetId: null,  // 流程设定编号
            functionName: null, // 功能名称
            order: null, // 序号
            action: null, // 访问方法
            pid: null, // 父ID
            operationId: null, // 操作编号
            path: null, // 路由路径
            name: null, // 路由名称
          };
          // 对每个key赋值
          for (const key in obj) {
            if (key !== "id") obj[key] = this.form[key];
          }
          // 判断流程顺序是否有一样
          if (this.editFlag) {
            // 如果修改过程中流程顺序没变则可直接保存
            if (this.nowSort != obj["order"]) {
              // 循环列表,判断表单中填入的流程是否已经存在
              for (let index = 0; index < this.tableData.length; index++) {
                // 得到每个obj
                const elem = this.tableData[index];
                // 将列表中流程与当前流程比较
                if (obj["order"] == elem["order"]) {
                  this.$alert(
                    "列表中已存在当前序号，请修改后再进行保存！",
                    "warning"
                  );
                  return false;
                }
              }
            }
          } else {
            for (let index = 0; index < this.tableData.length; index++) {
              // 得到每个obj
              const elem = this.tableData[index];
              // 将列表中流程与当前流程比较
              if (obj["order"] == elem["order"]) {
                this.$alert(
                  "列表中已存在当前流程顺序，请修改后再进行保存！",
                  "warning"
                );
                return false;
              }
            }
          }
          if (this.editFlag) {
            for (const key in this.multipleSelection[0]) {
              if (key !== "id") {
                this.multipleSelection[0][key] = obj[key];
              }
            }
          } else {
            obj.id = this.tableData.length * 1 + 1;
            // 回显列表
            this.tableData.push(obj);
          }
          // 关闭弹窗
          this.dialogVisible = false;
          this.editFlag = false;
          this.form = {
            id: null,
            processSetId: null,  // 流程设定编号
            functionName: null, // 功能名称
            order: null, // 序号
            action: null, // 访问方法
            pid: null, // 父ID
            operationId: null, // 操作编号
            path: null, // 路由路径
            name: null, // 路由名称
          };
          // 清除表单验证和数据
          this.$refs.form.$refs.enInform.resetFields();
          // 遍历formItem
          this.$refs.form.$refs.formItem.map(e => {
            // 找到所属机构和角色下拉框
            if (e.prop === "functionName") {
              // 置空
              e.$children[1].value = null;
            }
          });
        } else {
          // 错误提示
          this.$message.error("输入内容存在错误，请根据提示完善内容！");
          return false;
        }
      });
    },
    /**
     * 弹窗列表删除
     * @author 滕威
     */
    fun_Del() {
      if (this.multipleSelection.length === 0) {
        this.$alert("请至少选择一条数据！", "warning");
        return;
      }
      this.multipleSelection.forEach(element => {
        this.tableData.forEach((e, i) => {
          if (element.functionName == e.functionName) {
            this.tableData.splice(i, 1);
          }
        });
      });
    },
    /**
     * 点击修改按钮
     * @author 滕威
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          let obj = {
            id: null,
            processSetId: null,  // 流程设定编号
            processSetName: null,  // 流程设定编号名称
            functionName: null, // 功能名称
            order: null, // 序号
            action: null, // 访问方法
            pid: null, // 父ID
            operationId: null, // 操作编号
            path: null, // 路由路径
            name: null, // 路由名称
          };
          for (const key in obj) {
            obj[key] = this.multipleSelection[0][key];
          }
          // 将当前流程顺序赋值给全局变量
          this.nowSort = obj["order"];
          // 将当前步骤名称赋值给全局变量
          this.nowName = obj["functionName"];
          // 修改状态
          this.editFlag = true;
          // 赋值
          this.form = obj;
          // 打开弹窗
          this.dialogVisible = true;
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 弹窗关闭
     * @author 滕威
     */
    fun_Close() {
      // 修改状态
      this.editFlag = false;
      // 关闭弹窗
      this.dialogVisible = false;
      // 清除表单验证和数据
      this.$refs.form.$refs.enInform.resetFields();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     * @author 滕威
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框选择事件
     * @param {e} value
     * @param {i} 下拉框标识
     * @author 滕威
     */
    fun_GetSelectVal(e, i) {
      // 步骤名称
      if (i === "processSetName") {
        // 判断e是否为空
        if (e != "" && e != undefined) {
          // 将e进行分割
          var es = e.split(";");
          // 流程编号
          this.form.operationId = es[0]?es[0]:"";
          // 路由路径
          this.form.path = es[1]?es[1]:"";
          // 路由名称
          this.form.name = es[2]?es[2]:"";
          // 组件名称
          this.form.action = es[3]?es[3]:"";
          // 操作流程
          this.form.processSetName = es[4]?es[4]:"";
          // 序号
          this.form.order = es[5]?es[5]:"";
          // 赋值
          this.form[i] = e;
        }
      }else{
        // 赋值
        this.form[i] = e;
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 打开弹窗
          this.dialogVisible = true;
          break;
        case "修改":
          // 调用删除方法
          this.fun_Edit();
          break;
        default:
          // 调用删除方法
          this.fun_Del();
      }
    }
  }
};
